import { Route, Routes } from 'react-router-dom';
import { AdminRoutes } from './components/Admin/AdminRoutes';
import { Assets } from './components/Assets/Assets';
import { Index } from './components/Index/Index';
import { AdminProvider } from './context/Admin/admin';
import { HardwareProvider } from './context/hardware';
import { KeyboardProvider } from './context/Keyboard/keyboard';
import { LocalizationProvider } from './context/Localization/localization';
import { Lockers } from './context/lockers';
import { CssBaseLine } from './css/CssBaseLine';
import { isElectron } from './helpers/EnvironmentFlags/EnvironmentFlags';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider, createTheme } from '@mui/material';
import { SCREEN_LG, SCREEN_MD, SCREEN_SM, SCREEN_XL, SCREEN_XS } from './helpers/MediaQueries';
import { AppRoutePaths, PathName } from './helpers/Routes';
import { ErrorBoundaryFull, ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { KioskProvider } from './context/Kiosk/kiosk';
import { DevelopmentProvider } from './context/Development/Development';
import { AxiosProvider } from './context/Axios/Axios';

dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

if (isElectron() && window.Logger) {
    window.console.log = window.Logger.log;
    window.console.warn = window.Logger.warn;
    window.console.error = window.Logger.error;
}

export const theme = createTheme({
    breakpoints: {
        values: {
            xs: SCREEN_XS,
            sm: SCREEN_SM,
            md: SCREEN_MD,
            lg: SCREEN_LG,
            xl: SCREEN_XL,
        },
    },
    components: {
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                    '&.Mui-focused': {
                        backgroundColor: 'white',
                    },
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontSize: '0.875rem',
                    lineHeight: 1.43,
                    letterSpacing: '0.01071em',
                    backgroundColor: '#fafafa',
                },
            },
        },
    },
});

function App() {
    return (
        <ErrorBoundaryFull>
            <KeyboardProvider>
                <LocalizationProvider>
                    <StyledEngineProvider injectFirst>
                        <MuiThemeProvider theme={theme}>
                            <CssBaseLine />
                            <DevelopmentProvider>
                                <AxiosProvider>
                                    <HardwareProvider>
                                        <KioskProvider>
                                            <AdminProvider>
                                                <Lockers>
                                                    <ErrorBoundary>
                                                        <Routes>
                                                            {isElectron() ? <Route path={PathName(AppRoutePaths.Admin, '*')} element={<AdminRoutes />} /> : null}
                                                            <Route path={PathName(AppRoutePaths.Assets, '*')} element={<Assets />} />
                                                            <Route path={'*'} element={<Index />} />
                                                        </Routes>
                                                    </ErrorBoundary>
                                                </Lockers>
                                            </AdminProvider>
                                        </KioskProvider>
                                    </HardwareProvider>
                                </AxiosProvider>
                            </DevelopmentProvider>
                        </MuiThemeProvider>
                    </StyledEngineProvider>
                </LocalizationProvider>
            </KeyboardProvider>
        </ErrorBoundaryFull>
    );
}
export default App;
